import { createFileRoute } from "@tanstack/react-router";
import { VergleichDetail } from "../../features/shell/VergleichDetail";

export const Route = createFileRoute("/vergleiche/$vergleichId")({
  component: VergleichDetailRoute,
});

function VergleichDetailRoute() {
  const { vergleichId } = Route.useParams();
  return <VergleichDetail vergleichId={vergleichId} />;
}
